export default __webpack_public_path__ + "static/2019_04-c6e172262d9321dd4da09db7addd2c3c.png";